import PageLayout from "Layouts/PageLayout";
import { useTranslation } from "react-i18next";
import PrintIcon from "../../../Assets/SVG/PrintIcon";
import Button from "../../../Components/Button";
import CalculatorIcon from "../../../Assets/SVG/CalculatorIcon";
import {useNavigate} from "react-router-dom";
import useQueryParams from "../../../Hooks/UseQueryParams";
import {useProjectSettlementSettings} from "../../../Apis/ProjectSettlementSettingsApi";
import ProjectSettlementSettingsList from "../../../Features/Settlements/ProjectSettlementSettingsList";
import React from "react";
import Pagination from "../../../Components/Pagination";

const Index = () => {

    const { t } = useTranslation();

    const [ filter, setFilter ] = useQueryParams({});

    const { data: settlementSettings, isLoading } = useProjectSettlementSettings(filter);

    const navigate = useNavigate();

    return (
        <PageLayout title={t('settlementSettings')} icon={<CalculatorIcon />} header={(
            <Button prefix={<PrintIcon fill={"#FFF"} />} text={t('addSettlementSetting')} type={"primary"} onClick={() => navigate("new")} />
        )}>
            <>
                <ProjectSettlementSettingsList settlementSettings={settlementSettings?.items} isLoading={isLoading} />

                <Pagination paginatedList={settlementSettings} onPageChange={newPage => setFilter({page: newPage})} />
            </>
        </PageLayout>
    )
}

export default Index
